import { useQuery } from '@tanstack/react-query'
import axiosClient from '../../axios'

export interface CaseVisitorEntry {
  id: string
  createdAt: string
  viewerRole: 'guest' | 'admin' | 'super_admin'
  visitor: { name: string | null; email: string | null; isGuest: boolean }
  case: { id: string; label: string; pathologyName: string | null; ownerName: string | null }
}

export interface CaseVisitorsResponse {
  data: CaseVisitorEntry[]
  meta: { page: number; limit: number; totalItems: number; totalPages: number }
}

/** Admin — who viewed which blot case, and when (admin-shadow + no-account guest reads). */
export function useCaseVisitors(params: { search?: string; type?: 'guest' | 'admin'; page?: number; limit?: number }) {
  return useQuery({
    queryKey: ['admin', 'case-visitors', params],
    queryFn: async () => {
      const { data } = await axiosClient.get<CaseVisitorsResponse>('/admin/case-visitors', { params })
      return data
    },
  })
}
